import React, { useEffect, useRef } from 'react';

export default function SoldierBackground() {
  const particleCanvasRef = useRef(null);
  const particleFrameRef = useRef(null);

  useEffect(() => {
    const canvas = particleCanvasRef.current;
    if (!canvas) return undefined;
    const ctx = canvas.getContext('2d');

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const particles = Array.from({ length: 60 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.4,
      vy: (Math.random() - 0.5) * 0.4,
      r: Math.random() * 1.5 + 0.5,
      alpha: Math.random() * 0.5 + 0.1,
    }));

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((particle) => {
        particle.x += particle.vx;
        particle.y += particle.vy;
        if (particle.x < 0) particle.x = canvas.width;
        if (particle.x > canvas.width) particle.x = 0;
        if (particle.y < 0) particle.y = canvas.height;
        if (particle.y > canvas.height) particle.y = 0;

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(251, 191, 36, ${particle.alpha})`;
        ctx.fill();
      });

      for (let i = 0; i < particles.length; i += 1) {
        for (let j = i + 1; j < particles.length; j += 1) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 100) {
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.strokeStyle = `rgba(251, 191, 36, ${0.08 * (1 - dist / 100)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }

      particleFrameRef.current = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(particleFrameRef.current);
    };
  }, []);

  return (
    <>
      {/* Deep premium background gradient */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: -10,
          background: 'linear-gradient(135deg, #0a0a0f 0%, #0d1117 40%, #0f1923 70%, #111827 100%)',
          pointerEvents: 'none',
        }}
      />

      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: -9,
          background: 'radial-gradient(ellipse 80% 60% at 50% 20%, rgba(251,191,36,0.07) 0%, transparent 70%), radial-gradient(ellipse 50% 40% at 80% 80%, rgba(239,68,68,0.05) 0%, transparent 60%)',
          pointerEvents: 'none',
        }}
      />

      <canvas
        ref={particleCanvasRef}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: -7,
          pointerEvents: 'none',
        }}
      />

      {/* Grid overlay */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: -7,
          backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.03) 2px, rgba(0,0,0,0.03) 4px)',
          pointerEvents: 'none',
        }}
      />

      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: -7,
          backgroundImage: 'linear-gradient(rgba(251,191,36,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(251,191,36,0.025) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
          pointerEvents: 'none',
        }}
      />

      {/* Decorative corners */}
      <div style={{ position: 'fixed', top: 0, left: 0, zIndex: -6, pointerEvents: 'none' }}>
        <div style={{ width: 120, height: 2, background: 'linear-gradient(to right, rgba(251,191,36,0.6), transparent)' }} />
        <div style={{ width: 2, height: 120, background: 'linear-gradient(to bottom, rgba(251,191,36,0.6), transparent)' }} />
      </div>

      <div style={{ position: 'fixed', bottom: 0, right: 0, zIndex: -6, pointerEvents: 'none' }}>
        <div style={{ width: 120, height: 2, marginLeft: 'auto', background: 'linear-gradient(to left, rgba(251,191,36,0.6), transparent)' }} />
        <div style={{ width: 2, height: 120, marginLeft: 'auto', background: 'linear-gradient(to top, rgba(251,191,36,0.6), transparent)' }} />
      </div>
    </>
  );
}
